import {Component, Vue} from 'vue-property-decorator';
import {GetProductsRestockSearchResponse} from 'supporter';
import {DisplayEnum} from '@/types';
import {convertProductUri, toI18n} from '@/utils/commonUtils';

@Component({})
export default class RestockListDataMixin extends Vue {

  public invalidKeywordSwitch = false;
  public invalidKeywordText = '';
  public pDI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_PRODUCTLIST_' + needToI18nStr));
  }

  public searchType: DisplayEnum[] = [
    { value: 'PRODUCT_NO', label: toI18n(this.$t('PRODUCT_RESTOCK_OPTION_PRODUCT_NO'))},
    { value: 'OPTION_MANAGEMENT_CD', label: toI18n(this.$t('PRODUCT_RESTOCK_OPTION_MANAGE_CODE'))},
    { value: 'STOCK_NO', label: toI18n(this.$t('PRODUCT_RESTOCK_OPTION_STOCK_NO'))},
    { value: 'OPTION_NO', label: toI18n(this.$t('PRODUCT_RESTOCK_OPTION_NO'))},
  ];

  public sortTypeList: DisplayEnum[] = [
    {value: 'NONE', label: toI18n(this.$t('PRODUCT_RESTOCK_OPTION_ALIGN_STANDARD'))},
    {value: 'PRODUCT_NO_DESC', label: toI18n(this.$t('PRODUCT_RESTOCK_OPTION_ALIGN_DESC'))},
    {value: 'RESTOCK_CNT_DESC', label: toI18n(this.$t('PRODUCT_RESTOCK_OPTION_ALIGN_CNT_DESC'))},
    {value: 'NOT_SEND_CNT_DESC', label: toI18n(this.$t('PRODUCT_RESTOCK_OPTION_ALIGN_NOT_SEND_CNT_DESC'))},
  ];

  public gridResult: GetProductsRestockSearchResponse = {
    contents: [],
    totalPage: 0,
    totalCount: 0
  };

  public gridOptions?: {[propName: string]: any} = {
    id: 'member_list',
    columnOptions: {
      minWidth: 70,
      resizable: true,
      frozenCount: 4
    },
    bodyHeight: 400,
    rowHeight: 31,
    minRowHeight: 35,
    displayRowCount: 20,
    isInitialRequest: true,
    copyOptions: {
      useFormattedValue: true
    },
    heightResizable: true,
    pageOptions: {
      centerAlign: true,
    },
  };


  public gridProps: any = {
    columns: [
      {
        header: this.$t('COMMON_MALL'),
        name: 'mallName',
        align: 'center'
      },
      {
        header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_PARTNER'),
        name: 'partnerName',
        align: 'center'
      },
      {
        header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_PRODUCT_NO'),
        name: 'productNo',
        align: 'center',
        formatter: ({ row, value }: any): string => {
          const uri = convertProductUri(row.url, value);

          return `<a href="${uri}" target="_blank">${value}</a>`;
        }
      },
      {
        header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_PRODUCT_NAME'),
        name: 'productName',
        align: 'center',
        formatter: ({ row }): string => {
          return row.productName || this.$t('PRODUCT_RESTOCK_DELETED_PRODUCT') as string;
        }
      },
      {
        header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_OPTION_NO'),
        name: 'optionNo',
        align: 'center'
      },
      {
        header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_OPTION_NAME_AND_VALUE'),
        name: 'optionName',
        align: 'center',
        formatter: ({ row }): string => {
          const {optionType, optionName, optionValue} = row;
          if (!optionType) return this.$t('PRODUCT_RESTOCK_DELETED_OPTION') as string;
          return optionType === 'DEFAULT' ? '-' : `${row.optionName}:${row.optionValue}`;
        }
      },
      {
        header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_REQUEST_USER'),
        name: 'restockCount',
        align: 'center'
      },
      {
        header: this.$t('PRODUCT_RESTOCK_NOT_YET_SEND'),
        name: 'notSendCount',
        align: 'center'
      },
      {
        header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_REQ_USER_LIST'),
        name: 'partner',
        align: 'center',
        formatter: ({ row }): string => {
          return `<a href="/product/restock/detail?mallNo=${row.mallNo}&optionNo=${row.optionNo}">상세보기</a>`;
        }
      },
      {
        header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_RESERVATION_INVENTORY'),
        name: 'reservationStockCount',
        align: 'center',
        formatter: ({ row }): string => row.reservationStockCount ?? '-'
      },
      {
        header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_INVENTORY'),
        name: 'stockCount',
        align: 'center',
        formatter: ({ row }): string => {
          return row.stockCount === null ? '-' : row.stockCount;
        }
      },
      {
        header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_SALES_STATUS'),
        name: 'saleStatusType',
        align: 'center',
        formatter: ({ value }): string => value ? this.$t(`PRODUCT_RESTOCK_${value}`) as string : '-',
      },
      {
        header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_SALES_SETUP'),
        name: 'saleSettingStatusType',
        align: 'center',
        formatter: ({value}): string => value ? this.$t(`PRODUCT_RESTOCK_${value}`) as string : '-',
      },
      {
        header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_OPTION_AVAILABILITY'),
        name: 'useOption',
        align: 'center',
        formatter: ({ row, value }): string => {
          if (!row.optionType) return '-';
          return value ? 'Y' : 'N';
        }
      },
      { // 예약판매기간
        header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_PRE_SALE_PERIOD'),
        name: 'reservationPeriod',
        align: 'center',
        formatter: ({ value }): string => `${value ? value.startYmdt : ''} ~ ${value ? value.endYmdt : ''}`
      },
      {
        header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_SALE_PERIOD'),
        name: 'salePeriod',
        align: 'center',
        formatter: ({ value }): string => `${value ? value.startYmdt : ''} ~ ${value ? value.endYmdt: ''}`
      },
      {
        header: this.$t('PRODUCT_RESTOCK_TABLE_HEADER_EXHIBIT_STATUS'),
        name: 'frontDisplayable',
        align: 'center',
        formatter: ({value}): string => this.$t(`PRODUCT_RESTOCK_CAN${value ? '' : '_NOT'}_DISPLAY`) as string
      }
    ],
    options: {
      columnOptions: {
        resizable: true,
        minWidth: 50
      },
      rowHeaders: ['checkbox'],
      header: {
        height: 33
      },
      displayRowCount: 20,
      minRowHeight: 31,
      bodyHeight: 190,
      isInitialRequest: true,
      useClientSort: false,
      pageOptions: {
        perPage: 30, // select가 바뀔때 변경이 되어서 페이지네이션도 변경이 된다.
        page: 1,
        totalCount: 0
      }
    }

  };

  public inquiriesContentBottomOption = {
    haveConfigBtn: false,
    haveExcelDownBtn: false,
    onLoadSearch: false,
    name: 'inquiry_list'
  };
}